import React from 'react';
import isEqual from 'react-fast-compare';

import {ModifiedNucleotides} from 'biojs/Sequence';
import DataConnector from 'connect/DataConnector';
import * as FileConstants from 'folder-items/FileConstants';
import * as BioentityActions from 'inventory/BioentityActions';
import WorkspaceStore from 'sidebar/WorkspaceStore';
import licenses from 'user/Licenses';

interface EnhancedProps {
  activeWorkspaceId: string | null;
}

class ComputedTagFetcherConnector extends DataConnector<BaseComputedTagFetcherProps, EnhancedProps> {
  shouldSubscribeToRedux = false;
  stores = [WorkspaceStore];

  enhanceProps(): EnhancedProps {
    return {
      activeWorkspaceId: this.workspaceStore().getState().activeId,
    };
  }
}

export interface BaseComputedTagFetcherProps {
  fileId: string;
  proteinAminoAcids?: string | null;
  sequenceBases?: string | null;
  sequenceModifiedNucleotides?: ModifiedNucleotides | null;
  tags: Array<FileConstants.Tag>;
}

type ComputedTagFetcherProps = BaseComputedTagFetcherProps & EnhancedProps;

/*
 * Non-rendered component that listens to stores that maintain information about properties
 * that may have dependent computed tags. Refetches file's tags on changes of these properties.
 */
class ComputedTagFetcher extends React.Component<ComputedTagFetcherProps> {
  componentDidMount(): void {
    this._fetchTags();
  }

  componentDidUpdate(prevProps: ComputedTagFetcherProps): void {
    if (this.props.fileId !== this.props.activeWorkspaceId) {
      // We only need to refetch the file tags if it's the currently open workspace item
      return;
    }

    // This logic definitely misses data changes that impact CF computation (e.g. chemical structure,
    // sequence primers, etc).
    if (
      !isEqual(prevProps.proteinAminoAcids, this.props.proteinAminoAcids) ||
      !isEqual(prevProps.sequenceBases, this.props.sequenceBases) ||
      !isEqual(prevProps.sequenceModifiedNucleotides, this.props.sequenceModifiedNucleotides) ||
      !isEqual(prevProps.tags, this.props.tags)
    ) {
      this._fetchTags();
    }
  }

  _fetchTags(): void {
    // Computed fields are only enabled for enterprise users
    if (licenses.hasEnterprisePlan()) {
      BioentityActions.getTags(this.props.fileId);
    }
  }

  render(): null {
    return null;
  }
}

export default ComputedTagFetcherConnector.connect(ComputedTagFetcher);
